import { PropertyType as SrsPropertyType } from 'srs-middleware';
import { textClusters } from '../endpoints';

import { TypographWidgetWrapper } from './wrapper.jsx';
import { TypographWidgetKnobs } from './knobs.tsx';
import { TypographActions } from 'widgets/typograph/actions.jsx';
import { filterProperties } from 'utilities/srsUtils';

const types = [SrsPropertyType.Text];

export const config = {
	key: 'TYPOGRAPH',
	label: 'Text Cluster (beta)', // is "beta" okay @shawn?
	icon: 'heatmap',
	wrapper: TypographWidgetWrapper,
	endpoint: textClusters,
	Knobs: TypographWidgetKnobs,
	Actions: TypographActions,
	types: types,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {},
			},
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, [], types).length >= 1;
	},
};
